import { message } from "antd";
import { history } from "../hooks/history";
import { Login } from "../routers/routeName";

export const handleUnauthorizedResponse = (data: any) => {
  if (String(data?.code) !== "11") {
    return false;
  }

  message.error(data?.message || "用户未登录,请重新登录");
  localStorage.clear();
  sessionStorage.clear();
  history.replace(Login);
  return true;
};
